import React from 'react';
import { Link } from 'react-router-dom';
import { Tag, ChevronRight } from 'lucide-react';

export const CarpetPromoBadge = () => {
  return (
    <Link
      to="/services"
      className="group block mx-4 sm:mx-auto max-w-5xl mt-4"
      data-testid="carpet-promo-badge"
    >
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-emerald-700 via-green-600 to-emerald-700 shadow-2xl ring-2 ring-lime-300/60 hover:ring-lime-300 transition-all duration-300 hover:scale-[1.01]">
        {/* Shimmer effect */}
        <div className="absolute inset-0 bg-[linear-gradient(110deg,transparent_40%,rgba(190,242,100,0.25)_50%,transparent_60%)] bg-[length:200%_100%] animate-[shimmer_3s_linear_infinite]" aria-hidden="true"></div>

        <div className="relative flex items-center gap-3 sm:gap-5 px-4 sm:px-6 py-4">
          {/* Blinking lime dot */}
          <div className="relative flex-shrink-0">
            <span className="absolute inline-flex h-4 w-4 rounded-full bg-lime-300 opacity-75 animate-ping"></span>
            <span className="relative inline-flex rounded-full h-4 w-4 bg-lime-300"></span>
          </div>

          <Tag className="h-7 w-7 sm:h-8 sm:w-8 text-lime-300 flex-shrink-0 animate-pulse" />

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="bg-lime-300 text-emerald-900 px-2 py-0.5 rounded text-xs font-black uppercase tracking-wider">
                Offre limitée
              </span>
              <span className="text-white font-black text-base sm:text-xl tracking-wide">
                <span className="text-lime-300">−20 %</span> sur le nettoyage des tapis
              </span>
            </div>
            <p className="text-emerald-50 text-xs sm:text-sm mt-0.5 font-medium">
              Tapis persan, oriental, kilim, berbère, laine, soie, moquettes — profitez de cette remise dans nos 2 pressings AQUABLUENET.
            </p>
          </div>

          <ChevronRight className="h-6 w-6 sm:h-8 sm:w-8 text-lime-300 flex-shrink-0 group-hover:translate-x-1 transition-transform duration-300" />
        </div>
      </div>
    </Link>
  );
};
